export const email = "admin@abc.in";

export const pass = "admin";

export const newss = [
  {
    source: {
      id: "the-verge",
      name: "The Verge",
    },
    author: "Justine Calma",
    title:
      "A warming world gives viruses more chances to hitchhike from species to species",
    description:
      "New research warns that climate change could make it easier for viruses to leap from one species to another. That ultimately puts humans at greater risk from new zoonotic viruses, like the coronavirus that causes COVID-19.",
    url: "https://www.theverge.com/2022/4/28/23044725/climate-change-zoonotic-virus-spillover",
    urlToImage:
      "https://cdn.vox-cdn.com/thumbor/dAnhXYP-wba9LhJ8zLHwfLQVRy4=/0x287:4000x2381/fit-in/1200x630/cdn.vox-cdn.com/uploads/chorus_asset/file/23420588/496473194.jpg",
    publishedAt: "2022-04-28T09:00:00Z",
    content:
      "That puts humans at greater risk, too\r\nStraw-coloured fruit bats at their daytime roosts in Mushitu or ever-green swamp forest in April, 2014, Kasanka National Park, Zambia.\r\nPhoto credit should read… [+4679 chars]",
  },
  {
    source: {
      id: null,
      name: "New York Times",
    },
    author: "Chris Cameron",
    title: "Virus Cases Grow After White House Correspondents Dinner",
    description:
      "Secretary of State Antony J. Blinken was among the attendees reporting coronavirus infections on Wednesday.",
    url: "https://www.nytimes.com/2022/05/04/us/politics/covid-white-house-correspondents-dinner.html",
    urlToImage:
      "https://static01.nyt.com/images/2022/05/04/multimedia/04dc-superspreader-photo01/04dc-superspreader-photo01-facebookJumbo.jpg",
    publishedAt: "2022-05-05T02:01:48Z",
    content:
      "The growing number of cases presented another sign of an official Washington that has largely returned to prepandemic routines, even as officials still urge Americans to take precautions, and has dec… [+1157 chars]",
  },
  {
    source: {
      id: "bbc-news",
      name: "BBC News",
    },
    author: "https://www.facebook.com/bbcnews",
    title: "Covid: Woman caught virus twice within record 20 days",
    description:
      "Spanish researchers say it's the shortest-known gap between two coronavirus infections.",
    url: "https://www.bbc.co.uk/news/health-61161529",
    urlToImage:
      "https://ichef.bbci.co.uk/news/1024/branded_news/BBAA/production/_124224084_gettyimages-1297943796.jpg",
    publishedAt: "2022-04-20T23:30:04Z",
    content:
      "Image source, Getty Images\r\nImage caption, The woman, who was a Spanish healthcare worker, tested positive for Delta and then Omicron\r\nA 31-year-old healthcare worker caught Covid twice within 20 day… [+2447 chars]",
  },
  {
    source: {
      id: null,
      name: "New York Times",
    },
    author: "Sharon LaFraniere",
    title:
      "F.D.A. Expected to Soon Clear Pfizer Booster for Children Ages 5 to 11",
    description:
      "Given that the age group has the lowest coronavirus vaccination rate of all eligible Americans, public health experts are not expecting a rush for the booster.",
    url: "https://www.nytimes.com/2022/05/16/us/politics/fda-pfizer-booster-children.html",
    urlToImage:
      "https://static01.nyt.com/images/2022/05/16/multimedia/16virus-briefing-pfizer-pediatric-booster/16virus-briefing-pfizer-pediatric-booster-facebookJumbo.jpg",
    publishedAt: "2022-05-16T20:05:19Z",
    content:
      "There is no coronavirus vaccine available yet for children younger than 5, but data is rolling in from both Moderna and Pfizer on their clinical trial results and regulators are expected to decide if… [+1244 chars]",
  },
  {
    source: {
      id: "bbc-news",
      name: "BBC News",
    },
    author: null,
    title: "Asian Cup 2023: China withdraws as host due to Covid-19",
    description:
      "The Chinese Football Association withdraws as host of the 2023 Asian Cup due to the coronavirus pandemic.",
    url: "https://www.bbc.co.uk/sport/football/61448472",
    urlToImage:
      "https://ichef.bbci.co.uk/live-experience/cps/624/cpsprodpb/4739/production/_124733281_qatarafcasiancup2019cps1.jpg",
    publishedAt: "2022-05-14T08:50:23Z",
    content:
      "Qatar won the 2019 AFC Asian Cup\r\nChina has withdrawn as host of the 2023 Asian Cup because of Covid-19.\r\nThe 24-team competition was to be held across 10 cities from June next year.\r\nBut the country… [+638 chars]",
  },
  {
    source: {
      id: "bbc-news",
      name: "BBC News",
    },
    author: null,
    title: "Asian Games in China postponed because of Covid-19",
    description:
      "The Asian Games in China are postponed because of the coronavirus pandemic, says the Olympic Council of Asia.",
    url: "https://www.bbc.co.uk/sport/61345031",
    urlToImage:
      "https://ichef.bbci.co.uk/live-experience/cps/624/cpsprodpb/857B/production/_124617143_gettyimages-1240477831.jpg",
    publishedAt: "2022-05-06T08:24:19Z",
    content:
      "New dates for the Asian Games in Hangzhou have yet to be announced\r\nThe Asian Games in China have been postponed because of the coronavirus pandemic, says the Olympic Council of Asia (OCA).\r\nThe even… [+860 chars]",
  },
  {
    source: {
      id: null,
      name: "New York Times",
    },
    author: "The New York Times",
    title: "Tony Nominations: How to Watch, and What to Expect",
    description:
      "The nominations, honoring Broadway as the industry returned after the long coronavirus shutdown, will be announced at 9 a.m. Eastern. The virus posed a special challenge for nominators.",
    url: "https://www.nytimes.com/live/2022/05/09/theater/tony-awards",
    urlToImage:
      "https://static01.nyt.com/images/2022/05/09/arts/live-blog-20220509-tony-awards-header-award/09tonys-nominations-what-next-articleLarge.jpg",
    publishedAt: "2022-05-09T11:18:38Z",
    content:
      "A Strange Loop is in contention to pick up a nomination for best musical.Credit...Sara Krulwich/The New York Times\r\nHeres what to expect today:\r\nThere were nine new musicals this season, and just fiv… [+1687 chars]",
  },
  {
    source: {
      id: null,
      name: "New York Times",
    },
    author: "The New York Times",
    title: "Boston Marathon Live Updates: Race Returns to Patriots’ Day",
    description:
      "The marathon is finally back on the third Monday in April. The coronavirus forced organizers to cancel the race in 2020 and hold it in October last year.",
    url: "https://www.nytimes.com/live/2022/04/18/sports/boston-marathon",
    urlToImage:
      "https://static01.nyt.com/images/2022/04/18/multimedia/live-blog-20220418-boston-marathon-header1/live-blog-20220418-boston-marathon-header1-articleLarge.jpg",
    publishedAt: "2022-04-18T11:59:45Z",
    content:
      "Runners from Russia and Belarus will not be allowed to compete in the Boston Marathon on Monday, another example of the countries deepening isolation over the invasion of Ukraine.Like so many around … [+2035 chars]",
  },
  {
    source: {
      id: null,
      name: "Gizmodo.com",
    },
    author: "Phillip Tracy",
    title: "10 Things to Know Before You Build a Desktop",
    description:
      "The last few years haven’t been kind to the PC builder community. As we all know, the chip shortage caused by the coronavirus pandemic has raised the price of key components, putting many projects on hold.Read more...",
    url: "https://gizmodo.com/10-desktop-build-tips-nvidia-amd-intel-pcpartpicker-1848825797",
    urlToImage:
      "https://i.kinja-img.com/gawker-media/image/upload/c_fill,f_auto,fl_progressive,g_center,h_675,pg_1,q_80,w_1200/a7cd0658613c1837e0525f9f44ccb2d8.jpg",
    publishedAt: "2022-04-22T13:00:00Z",
    content:
      "The last few years havent been kind to the PC builder community. As we all know, the chip shortage caused by the coronavirus pandemic has raised the price of key components, putting many projects on … [+890 chars]",
  },
  {
    source: {
      id: null,
      name: "New York Times",
    },
    author: "Tracey Tully",
    title: "A Police Sergeant Nearly Died of Covid-19. He Was Unvaccinated.",
    description:
      "Frank Talarico, a 47-year-old police sergeant, was hospitalized for 49 days with the coronavirus. “If I was vaccinated,” he said, “I wouldn’t have gotten as sick as I did.”",
    url: "https://www.nytimes.com/2022/04/26/nyregion/police-vaccine-nj.html",
    urlToImage:
      "https://static01.nyt.com/images/2022/04/13/nyregion/00nj-unvaccinated/00nj-unvaccinated-facebookJumbo.jpg",
    publishedAt: "2022-04-26T09:00:07Z",
    content:
      "At 5 one morning, as he struggled to breathe, she called the ambulance again.\r\nHe was readmitted with the foot-long blood clot in his lungs. Known as a pulmonary embolism, it has become a common side… [+1364 chars]",
  },
  {
    source: {
      id: "reuters",
      name: "Reuters",
    },
    author: null,
    title: "What you need to know about the coronavirus right now - Reuters",
    description:
      "What you need to know about the coronavirus right now  Reuters",
    url: "https://www.reuters.com/business/healthcare-pharmaceuticals/what-you-need-know-about-coronavirus-right-now-2022-04-27/",
    urlToImage:
      "https://www.reuters.com/resizer/0ME1Cc2tWOJpiTptXLImAbmm0PM=/1200x628/smart/filters:quality(80)/cloudfront-us-east-2.images.arcpublishing.com/reuters/MWVAD25XYBPNHIYVPA42WPNQE4.jpg",
    publishedAt: "2022-04-27T12:15:00Z",
    content:
      "April 27 (Reuters) - Here's what you need to know about the pandemic right now:\r\nChina's capital in race to detect COVID cases\r\nMillions of people in Beijing took their second COVID-19 tests of the w… [+3541 chars]",
  },
  {
    source: {
      id: "reuters",
      name: "Reuters",
    },
    author: null,
    title: "What you need to know about the coronavirus right now - Reuters",
    description:
      "What you need to know about the coronavirus right now  Reuters",
    url: "https://www.reuters.com/business/healthcare-pharmaceuticals/what-you-need-know-about-coronavirus-right-now-2022-04-19/",
    urlToImage:
      "https://www.reuters.com/resizer/9eL7UuBG_RSN6zGxOgX_UhhfrWI=/1200x628/smart/filters:quality(80)/cloudfront-us-east-2.images.arcpublishing.com/reuters/L3OJ5V6ZGNLETOZUDGVRH7KW3I.jpg",
    publishedAt: "2022-04-19T12:29:00Z",
    content:
      "April 19 (Reuters) - Here's what you need to know about the pandemic right now:\r\nU.S. will no longer enforce mask mandate on airplanes, trains\r\nThe Biden administration will no longer enforce a U.S. … [+3491 chars]",
  },
  {
    source: {
      id: "reuters",
      name: "Reuters",
    },
    author: null,
    title:
      "What you need to know about the coronavirus right now - Reuters.com",
    description:
      "What you need to know about the coronavirus right now  Reuters.com",
    url: "https://www.reuters.com/business/healthcare-pharmaceuticals/what-you-need-know-about-coronavirus-right-now-2022-05-17/",
    urlToImage:
      "https://www.reuters.com/resizer/p0Nbcfy8Yt6aDJvr12GfGToflIQ=/1200x628/smart/filters:quality(80)/cloudfront-us-east-2.images.arcpublishing.com/reuters/L7TYY3V2SFJRJPZ3GKTU35NE3E.jpg",
    publishedAt: "2022-05-17T12:12:00Z",
    content:
      "May 17 (Reuters) - Here's what you need to know about the pandemic right now:\r\nShanghai hits prized 'zero COVID' status but lockdown lingers\r\nShanghai achieved its long-awaited milestone of three con… [+2870 chars]",
  },
  {
    source: {
      id: "reuters",
      name: "Reuters",
    },
    author: null,
    title:
      "What you need to know about the coronavirus right now - Reuters.com",
    description:
      "What you need to know about the coronavirus right now  Reuters.com",
    url: "https://www.reuters.com/business/healthcare-pharmaceuticals/what-you-need-know-about-coronavirus-right-now-2022-05-04/",
    urlToImage:
      "https://www.reuters.com/resizer/Hr3bZj_4q2iab932DRLvXzMc42I=/1200x628/smart/filters:quality(80)/cloudfront-us-east-2.images.arcpublishing.com/reuters/NMD6HP6Q5NJQZEZDDXHPKAYJA4.jpg",
    publishedAt: "2022-05-04T12:22:00Z",
    content:
      "May 4 (Reuters) - Here's what you need to know about the pandemic right now:\r\nBeijing restricts public transport as COVID spreads in China\r\nThe Chinese capital Beijing shut dozens of metro stations a… [+3523 chars]",
  },
  {
    source: {
      id: "reuters",
      name: "Reuters",
    },
    author: null,
    title: "What you need to know about the coronavirus right now - Reuters",
    description:
      "What you need to know about the coronavirus right now  Reuters",
    url: "https://www.reuters.com/business/healthcare-pharmaceuticals/what-you-need-know-about-coronavirus-right-now-2022-05-06/",
    urlToImage:
      "https://www.reuters.com/resizer/RkeX4fj84ZuQj9Chv82Dm4KECkc=/1200x628/smart/filters:quality(80)/cloudfront-us-east-2.images.arcpublishing.com/reuters/AMZ2KFNO5FPCBMPNI4RQWT7JNA.jpg",
    publishedAt: "2022-05-06T12:35:00Z",
    content:
      "May 6 (Reuters) - Here's what you need to know about the pandemic right now:\r\nChina hits back at 'zero COVID' doubters\r\nResidents of Beijing fretted on Friday over dozens of new COVID-19 cases report… [+3656 chars]",
  },
  {
    source: {
      id: "reuters",
      name: "Reuters",
    },
    author: null,
    title:
      "What you need to know about the coronavirus right now - Reuters.com",
    description:
      "What you need to know about the coronavirus right now  Reuters.com",
    url: "https://www.reuters.com/business/healthcare-pharmaceuticals/what-you-need-know-about-coronavirus-right-now-2022-04-20/",
    urlToImage:
      "https://www.reuters.com/resizer/BZ8Ww9ApxQrajLjaVtSgWgixgCI=/1200x628/smart/filters:quality(80)/cloudfront-us-east-2.images.arcpublishing.com/reuters/6PEXXKOLUJJ6JJ2P5BZILKD5SU.jpg",
    publishedAt: "2022-04-20T13:01:00Z",
    content:
      "April 20 (Reuters) - Here's what you need to know about the pandemic right now:\r\nShanghai hopes COVID tide turning\r\nChina's commercial capital of Shanghai reported no new COVID-19 infections outside … [+3511 chars]",
  },
  {
    source: {
      id: "reuters",
      name: "Reuters",
    },
    author: null,
    title: "What you need to know about the coronavirus right now - Reuters",
    description:
      "What you need to know about the coronavirus right now  Reuters",
    url: "https://www.reuters.com/business/healthcare-pharmaceuticals/what-you-need-know-about-coronavirus-right-now-2022-04-22/",
    urlToImage:
      "https://www.reuters.com/resizer/-N_LoVg20IqA-GAKXkDFYGmAUmQ=/1200x628/smart/filters:quality(80)/cloudfront-us-east-2.images.arcpublishing.com/reuters/6OKVKXGXZRNZBI4BXKTAUPD73I.jpg",
    publishedAt: "2022-04-22T12:39:00Z",
    content:
      "April 22 (Reuters) - Here's what you need to know about the pandemic right now:\r\nWHO backs Pfizer's oral COVID therapy for high-risk patients\r\nThe World Health Organization (WHO) on Thursday endorsed… [+3422 chars]",
  },
  {
    source: {
      id: "reuters",
      name: "Reuters",
    },
    author: null,
    title: "What you need to know about the coronavirus right now - Reuters",
    description:
      "What you need to know about the coronavirus right now  Reuters",
    url: "https://www.reuters.com/business/healthcare-pharmaceuticals/what-you-need-know-about-coronavirus-right-now-2022-04-25/",
    urlToImage:
      "https://www.reuters.com/resizer/199wUdBhpMmR4u14-S7xdtWQMj0=/1200x628/smart/filters:quality(80)/cloudfront-us-east-2.images.arcpublishing.com/reuters/ZVV3K3C56ZME5FFVYARC3WKXYQ.jpg",
    publishedAt: "2022-04-25T13:13:00Z",
    content:
      "April 25 (Reuters) - Here's what you need to know about the pandemic right now:\r\nBeijing residents hit the stores amid lockdown fears\r\nA mass COVID-19 testing order in Beijing's biggest district prom… [+3008 chars]",
  },
  {
    source: {
      id: "cnn",
      name: "CNN",
    },
    author: "Jacopo Prisco, CNN",
    title: "Decoding the hidden messages in one city's street art revival",
    description:
      "Cita Sadeli saw the start of the pandemic from a different angle than most: standing on an articulated lift, hovering 120 feet above street level. She spent much of early March 2020 painting a mural on the exterior of Hotel Xena in downtown Washington, DC, wa…",
    url: "https://www.cnn.com/style/article/cita-sadeli-miss-chelove-street-art-nomad/index.html",
    urlToImage:
      "https://cdn.cnn.com/cnnnext/dam/assets/220511161237-01-miss-chelove-washington-dc-nomad-super-tease.jpg",
    publishedAt: "2022-05-13T21:22:22Z",
    content:
      "arts\r\nCita Sadeli saw the start of the pandemic from a different angle than most: standing on an articulated lift, hovering 120 feet above street level. She spent much of early March 2020 painting a … [+5990 chars]",
  },
  {
    source: {
      id: "reuters",
      name: "Reuters",
    },
    author: null,
    title:
      "Colombia to offer second coronavirus booster shots to over 50s, others - Reuters",
    description:
      "Colombia will offer a second coronavirus booster shot to people aged 50 and over, the government said on Friday.",
    url: "https://www.reuters.com/business/healthcare-pharmaceuticals/colombia-offer-second-coronavirus-booster-shots-over-50s-others-2022-05-06/",
    urlToImage:
      "https://www.reuters.com/resizer/eES_bGlwnxebFMnQVvcFEbmuq8w=/1200x628/smart/filters:quality(80)/cloudfront-us-east-2.images.arcpublishing.com/reuters/ZPHXWVCXOVP5VJUWDQABZMSJFY.jpg",
    publishedAt: "2022-05-06T17:28:00Z",
    content:
      "BOGOTA, May 6 (Reuters) - Colombia will offer a second coronavirus booster shot to people aged 50 and over, the government said on Friday.\r\nColombia has reported just under 6.1 million confirmed coro… [+1180 chars]",
  },
];
